import React from "react";
import { ApolloProvider } from "@apollo/react-hooks";
import { PdUIKitProvider } from "@pd/pd-ui-kit";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";

import { client } from "./client";
import { DefaultLayout } from "~/components/Layout";
import { UserProvider } from "~/shared/context/UserContext";
import Notifications from "~/components/Notifications/";

import { SkeletonTheme } from "react-loading-skeleton";
import "core-js/stable";
import "./language";
import { PermissionProvider } from "~/shared/context/PermissionContext";
import { DealerContextProvider } from "./app/Context/DealerContext";

const queryClient = new QueryClient();

export const App = () => {
  console.log(process.env);

  return (
    <PdUIKitProvider>
      {/*@ts-ignore*/}
      <ApolloProvider client={client}>
        <QueryClientProvider client={queryClient}>
          <PdUIKitProvider>
          <DealerContextProvider>
            <SkeletonTheme color="#c5c5c5" highlightColor="#b9b9b9">
              <BrowserRouter>
                <UserProvider>
                  <PermissionProvider>
                    <DefaultLayout />
                  </PermissionProvider>
                </UserProvider>
              </BrowserRouter>
              <Notifications />
            </SkeletonTheme>
          </DealerContextProvider>
          </PdUIKitProvider>
        </QueryClientProvider>
      </ApolloProvider>
    </PdUIKitProvider>
  );
};
